import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  CreateGeographicZonePayload,
  GeographicZone,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/geographicZones`;

export const createGeographicZoneCommand = async ({
  sellerId,
  payload,
}: {
  sellerId: string;
  payload: CreateGeographicZonePayload;
}): Promise<BackResponse<GeographicZone> | BackResponseFailure> => {
  try {
    return await apiCall<BackResponse<GeographicZone>>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId),
      {
        method: SUPPORTED_METHODS.POST,
        json: payload,
      },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
